import { useEffect } from 'react';
import { WizardStepBaseProps } from '../../../wizard/interfaces/wizard-step-base-props';
import { SelectDestinationType } from '../../SelectDestinationType/SelectDestinationType';
import styles from './CreateDestinationSelectDestinationType.module.scss';
import { DestinationType } from '../../../shared/interfaces/destination';
import { useAnalyticsTracker } from '../../../tracking/hooks/useAnalyticsTracker';
import { DestinationTrackers } from '../../tracking/destination-trackers';

export function CreateDestinationSelectDestinationType({
  completeStep,
  onDataChange,
  updateWizardStepFooterProps
}: WizardStepBaseProps) {
  const { eventTrack } = useAnalyticsTracker();

  useEffect(() => {
    updateWizardStepFooterProps({
      entity: 'Destination'
    });

    return () => {
      updateWizardStepFooterProps({});
    };
  }, []);

  const onDestinationTypeSelect = (destinationType: DestinationType) => {
    eventTrack({
      action: DestinationTrackers.DESTINATION_TRACKER_ADD_DESTINATION_DESTINATION_TYPE_SELECT,
      properties: {
        destinationType
      }
    });

    onDataChange({ destinationType: destinationType.destinationType });
    completeStep();
  };

  return (
    <div className='scrollable-content'>
      <div className={styles.addDestinationSelectDestinationType}>
        <SelectDestinationType onDestinationTypeSelect={onDestinationTypeSelect} />
      </div>
    </div>
  );
}
